import type { Banner } from '../../../../services/ui';
import type { CategoriesStore } from '../../../../stores/categories/CategoriesStore';
import { GameProvider, type Game } from '../../../../stores/game/types';

export const getRiveUrl = (banner: Banner, isMobile: boolean): string => {
  const { mobileBanner, desktopBanner } = banner;
  const mobileUrl = mobileBanner?.animationUrl;
  const desktopUrl = desktopBanner?.animationUrl;

  if (isMobile && mobileUrl) {
    return mobileUrl;
  }
  return desktopUrl ?? '';
};

export const getRiveBackgroundUrl = (banner: Banner, isMobile: boolean): string => {
  const { mobileBanner, desktopBanner } = banner;
  const mobileUrl = mobileBanner?.mobileAnimationBackgroundUrl;
  const desktopUrl = desktopBanner?.animationBackgroundUrl;

  if (isMobile && mobileUrl) {
    return mobileUrl;
  }
  return desktopUrl ?? '';
};

/**
 * Finds the Crown Slots provider ID by searching through categories
 * @param categoriesStore - The categories store instance
 * @returns Crown Slots provider ID or null if not found
 */
export const findCrownSlotsProviderId = (categoriesStore: CategoriesStore): number | null => {
  for (const categoryId of categoriesStore.categoriesIds) {
    const category = categoriesStore.categoriesRegistry[categoryId];
    if (category) {
      const crownSlotsGame = category.subCategoryGames.find(
        (game: Game) => game?.masterCasinoProvider?.name === GameProvider.Crownslots,
      );
      if (crownSlotsGame) {
        return crownSlotsGame.masterCasinoProviderId;
      }
    }
  }
  return null;
};
